<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :items="staffs"
    v-bind="this.$attrs"
    :options.sync="tableOptions"
    loading-text="Đang Tải"
    :server-items-length="totalItems"
    :footer-props="footerTable"
    :loading="loading"
    disable-sort
  >
    <template v-slot:[`item.name`]="{ item }">
      <router-link style="text-decoration: none" :to="'/staff/' + item.id">
        {{ item.name }}
      </router-link>
    </template>
    <template v-slot:[`item.createdAt`]="{ item }">
      {{ item.createdAt | ddmmyyyy }}
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-tooltip
        max-width="250px"
        bottom
        v-if="$_get(item, 'role.name', '').toLowerCase() !== 'manager' && $auth.policies['update-password-staff']"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon @click="() => onChangePassword(item)">
            <v-icon>mdi-lock-reset</v-icon>
          </v-btn>
        </template>
        <span>Đổi mật khẩu</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'
const originHeaders = [
  { text: 'Tên', value: 'name' },
  { text: 'Tài khoản', value: 'code' },
  { text: 'Vai trò', value: 'role.description' },
  { text: 'Email', value: 'email' },
  { text: 'Số Điện Thoại', value: 'phone' },
  { text: 'Ngày tạo', value: 'createdAt' },
  { text: 'Thao tác', value: 'action', align: 'center' }
]

export default {
  props: {
    role: String
  },
  data() {
    return {
      headers: originHeaders,
      draw: false,
      search: '',
      status: null,
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      isLoading: false,
      createState: false,
      tableOptions: {}
    }
  },
  created() {
    this.refresh()
  },
  computed: {
    ...mapState('staff', ['staffs', 'count', 'staff', 'totalItems', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số dòng mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },

    titleBtn() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm Nhân Viên'
      }
    }
  },
  methods: {
    ...mapActions('staff', ['searchStaffs', 'requestPageSettings']),
    async refresh(query) {
      await this.searchStaffs(query)
    },
    onChangePassword(item) {
      this.$emit('onChangePassword', item.user)
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  }
}
</script>
